import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Loader } from "../../../../components/loader/loader.component";
import AllianzLogo from "../../images/allianz.png";
import CardifLogo from "../../images/cardif.png";
import HestiaLogo from "../../images/hestia.png";
import VersicherungLogo from "../../images/versicherung.png";
import WartaLogo from "../../images/warta.png";
import CompensaLogo from "../../images/compensa.png";
import PzuLogo from "../../images/pzu.png";
import { selectInsuranceCompanies } from "../../redux/idd.selectors";
import { SectionTitle } from "../filesToDownload/filesToDownload.styled";

import {
  Container,
  Content,
  CompanyList,
  CompanyLogo,
  StyledIcon,
} from "./insuranceCompanyBox.styled";
import { InsuranceCompany } from "./insuranceCompanyBox.constants";

export const InsuranceCompanyBox = ({ className }) => {
  const { t } = useTranslation();
  const companies = useSelector(selectInsuranceCompanies);

  const getCompanyLogo = (company) => {
    switch (company) {
    case InsuranceCompany.Allianz: return AllianzLogo;
    case InsuranceCompany.Cardif: return CardifLogo;
    case InsuranceCompany.CardifLife: return CardifLogo;
    case InsuranceCompany.CardifArd: return CardifLogo;
    case InsuranceCompany.Hestia: return HestiaLogo;
    case InsuranceCompany.Versicherung: return VersicherungLogo;
    case InsuranceCompany.Warta: return WartaLogo;
    case InsuranceCompany.Compensa: return CompensaLogo;
    case InsuranceCompany.Pzu: return PzuLogo;
    }
  };

  if (!companies?.length) return null;

  return (
    <Container className={className}>
      <SectionTitle>{t("idd.insuranceCompanyBox.insuranceCompanies")}</SectionTitle>
      <Content>
        <StyledIcon />
        {companies ? (
          <CompanyList>
            {companies.map(({ id, name }) => (
              name === InsuranceCompany.CardifLife
                && companies.find((item) => item.name === InsuranceCompany.CardifArd)
                ? null
                : <CompanyLogo key={id} src={getCompanyLogo(name)} />
            ))}
          </CompanyList>
        ) : (
          <Loader />
        )}
      </Content>
    </Container>
  );
};
